/**
 * Storage adapter for useFeedback hook.
 * persistentStorage: persists across sessions (SecureStore on native, localStorage on web)
 * sessionOnlyStorage: in-memory, cleared on app restart (no sessionStorage on native)
 */
import { Platform } from 'react-native'
import { storage } from '../utils/storage'

// In-memory cache for sync access (loaded from async storage on demand)
const cache: Record<string, string> = {}

// Session-only (in-memory, no persistence)
const sessionCache: Record<string, string> = {}

export const persistentStorage = {
  get(key: string): string | null {
    if (cache[key] !== undefined) return cache[key]
    // On web, read through to localStorage (sync) to avoid stale cache misses
    if (Platform.OS === 'web') {
      try {
        const val = localStorage.getItem(key)
        if (val !== null) { cache[key] = val; return val }
      } catch {}
    }
    return null
  },
  set(key: string, value: string): void {
    cache[key] = value
    // Fire-and-forget async persist
    storage.set(key, value).catch(() => {})
  },
  async load(key: string): Promise<void> {
    const val = await storage.get(key)
    if (val !== null) cache[key] = val
  },
}

export const sessionOnlyStorage = {
  get(key: string): string | null {
    return sessionCache[key] ?? null
  },
  set(key: string, value: string): void {
    sessionCache[key] = value
  },
}
